/**
 * Extrait de description (fiche produit).
 *
 * Le défilement natif vers une ancre ne fonctionne pas sur ce thème : la
 * navigation par fragment ne déplace pas la page. On intercepte donc le clic
 * pour appeler scrollIntoView, qui respecte bien le scroll-margin-top posé sur
 * la section Description.
 */
(() => {
  const LINK_SELECTOR = '.product-description-excerpt__link';

  const scrollToDescription = (link) => {
    const href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return false;

    const target = document.querySelector(href);
    if (!target) return false;

    // Déplie l'onglet Description s'il a été refermé par la cliente.
    const collapsibleTab = target.querySelector('.collapsible-tab:not(.open)');
    if (collapsibleTab) {
      const button = collapsibleTab.querySelector('collapsible-button');
      if (button) button.click();
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', href);
    }

    return true;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest ? event.target.closest(LINK_SELECTOR) : null;
    if (!link) return;

    if (scrollToDescription(link)) event.preventDefault();
  });
})();
